export default function Footer() {
  const navItems = [
    { label: '热门话题', href: '#topics' },
    { label: '平台优势', href: '#features' },
    { label: '精选推荐', href: '#carousel' },
    { label: '热播榜单', href: '#ranking' },
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-300/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-line text-background-50 text-lg"></i>
              </div>
              <span className="text-background-50 text-lg font-semibold font-heading">神马视频</span>
            </div>
            <p className="text-sm text-background-300/50 leading-relaxed mb-4">
              神马视频提供91视频、91在线视频、97视频、51视频等数字系列视频网站免费在线观看，高清影视大全不缓冲流畅播放，电视剧电影一应俱全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); handleClick('#hero'); }} className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-home-line text-background-400 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleClick('#contact'); }} className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-400 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-background-200 text-sm font-semibold mb-4 font-heading">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                  className="text-sm text-background-300/50 hover:text-primary-400 transition-colors py-1 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-background-200 text-sm font-semibold mb-4 font-heading">热门标签</h3>
            <div className="flex flex-wrap gap-2">
              {['91视频', '91在线视频', '97视频', '51视频', '高清影视', '免费在线观看', '不缓冲', '电视剧全集'].map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-lg bg-background-800 text-xs text-background-300/50 whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-background-200 text-sm font-semibold mb-4 font-heading">合作伙伴</h3>
            <div className="flex flex-wrap gap-2">
              <span className="px-2.5 py-1 rounded-lg bg-background-800 text-xs text-background-300/40 whitespace-nowrap">更多伙伴加入中</span>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400/40">© 2026 神马视频 | 91视频、91在线视频免费在线观看全集 | 97视频51视频高清影视大全不缓冲</p>
          <p className="text-xs text-background-400/30">本站内容仅供学习交流，不存储任何视频文件</p>
        </div>
      </div>
    </footer>
  );
}